import { render, staticRenderFns } from "./Dyson.vue?vue&type=template&id=1655f9b4&scoped=true&"
import script from "./Dyson.vue?vue&type=script&lang=js&"
export * from "./Dyson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1655f9b4",
  null
  
)

/* custom blocks */
import block0 from "./Dyson.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports